import { ShieldCheck, Code2, Server, Cpu, HardDrive, Globe2, Coins } from "lucide-react";

const ITEMS = [
    { icon: ShieldCheck, label: "Patent Filed" },
    { icon: Code2, label: "EVM Compatible" },
    { icon: Server, label: "DePIN Native" },
    { icon: Cpu, label: "AI Compute" },
    { icon: HardDrive, label: "Encrypted Storage" },
    { icon: Globe2, label: "On-Chain DNS" },
    { icon: Coins, label: "Developer Rev Share" },
];

export default function TrustStrip() {
    return (
        <section className="relative border-y border-line bg-card" data-testid="trust-strip">
            <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10 py-5 sm:py-6">
                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-7 gap-3 md:gap-5 items-center">
                    {ITEMS.map((it, i) => (
                        <div key={i} className="flex items-center justify-center md:justify-start gap-2" data-testid={`trust-item-${i}`}>
                            <it.icon size={14} className="text-brand-cyan shrink-0" strokeWidth={1.5} />
                            <span className="font-mono text-[10px] uppercase tracking-[0.16em] text-muted-ink whitespace-nowrap">
                                {it.label}
                            </span>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
